import React, { useState } from 'react'
import { Button } from 'primereact/button'
import { FaFilePdf } from 'react-icons/fa'
import { handlePostRequest } from '../../services/PostTemplate'
import moment from 'moment'

const DownloadAccountStatement = ({ formData }) => {


    const [loading, setLoading] = useState(false)

    const downloadAccStatement = async () => {

        setLoading(true)

        const data = {
            "account_number": formData?.mobileNo,
            "pdf_start_date": moment(formData?.fromDate).format("DD-MMM-YY").toUpperCase(),
            "pdf_end_date": moment(formData?.toDate).format("DD-MMM-YY").toUpperCase(),
            "generated_by": "CorporatePortal"
        }

        const response = await handlePostRequest(data, "zbizgateway/accountMaintainence/eAccountStatement");
        if (response?.responsecode == 1) {
            const parsedUrl = JSON.parse(response?.data)
            const url = parsedUrl?.pdf_data_uri_base64
            const pdfLink = url;
            const anchorElement = document.createElement('a');
            const fileName = `Corporate Account Statement.pdf`;
            anchorElement.href = pdfLink;
            anchorElement.download = fileName;
            anchorElement.click();
        }

        setLoading(false)

    }

    return (
        <>
            <div className='card'>
                <Button className="p-pl-2" loading={loading} onClick={downloadAccStatement}> <FaFilePdf /> Download PDF</Button>
            </div>
        </>
    )
}

export default DownloadAccountStatement